import { FileRaw } from '@/typings/api/FileRaw'
import { School } from '@/typings/api/School'
import { Roadmap } from '@/typings/api/Roadmap'
import { RoadmapEventStatuses } from './RoadmapEvent'

import variables from '@/assets/scss/exports.scss'


export const enum ReportCodes {
  directionEventStatistics = 'roadmap.direction_event_statistics',
  basicStatistics = 'roadmap.basic_statistics',
  common = 'roadmap.common',
  userActivity = 'roadmap.activity',
  dataCollection = 'data_collection.data_collection',
  dataCollectionStatuses = 'data_collection.data_collection_statuses',
  storage = 'publication.file_downloads_ate',
  storageFile = 'publication.file_downloads',
  individualStorageFileReport = 'publication.individual_storage_files',
  expert = 'roadmap.experts',
  all = 'roadmap.all',
}

export const enum ReportStatuses {
  ready = 'ready',
  pending = 'pending',
  in_progress = 'in_progress',
  done = 'done',
  error = 'error',
}


export const getReportStatusSettings = (status: ReportStatuses) => {
  switch (status) {
    case ReportStatuses.ready:
      return {
        id: status,
        label: 'Сформировать',
        icon: 'mdi-wrench-outline',
        color: variables['webflow-color-blue-dark'],
      }
    case ReportStatuses.pending:
    case ReportStatuses.in_progress:
      return {
        id: status,
        label: 'Проверить статус',
        icon: 'mdi-clock-outline',
        color: variables['webflow-color-blue-dark'],
      }

    case ReportStatuses.done:
      return {
        id: status,
        label: 'Загрузить отчет',
        icon: 'mdi-check',
        color: variables['webflow-color-green'],
      }

    case ReportStatuses.error:
      return {
        id: status,
        label: 'Ошибка',
        icon: 'mdi-alert-circle-outline',
        color: variables['webflow-color-red'],
      }

    default:
      return {
        id: status,
        label: status as string,
        icon: 'mdi-help-circle-outline',
        color: variables['webflow-color-grey'],
      }
  }
}

export interface Report {
  id: number;
  created_at: string;
  code: ReportCodes;
  error_msg: null | string;
  raw_file: null | FileRaw;
  status: ReportStatuses;
  title: string;
  has_raw_data: boolean;
}

export interface ReportCollection extends Report {
  raw_data?: never;
}


// common /////////////////////////////////////////


export const enum ReportDataCommonRowType {
  direction = 'direction',
  event = 'event',
}

type ReportDataRowCommon = {
  end_at: string | null;
  files: [];
  id: number;
  is_confirmed: boolean;
  name: string;
  number: string;
}

export type ReportDataCommonRow =
  | ReportDataRowCommon & {
    status: null;
    type: ReportDataCommonRowType.direction;
  }
  | ReportDataRowCommon & {
    status: RoadmapEventStatuses;
    type: ReportDataCommonRowType.event;
  }

export interface ReportDataCommonRoadmap {
  id: Roadmap['id'];
  name: Roadmap['name'];
  rows: ReportDataCommonRow[];
}

interface ReportDataCommonSchool {
  code: School['code'];
  id: School['id'];
  roadmaps: ReportDataCommonRoadmap[];
}

export interface ReportDataCommon {
  vent_completed_count: number;
  event_done_count: number;
  event_in_progress_count: number;
  event_needs_check_count: number;
  event_not_completed_count: number;
  event_undone_count: number;
  schools: ReportDataCommonSchool[];
}


// Basic Static ///////////////////////////////////


export const enum ReportDataBasicStaticRowType {
  region = 'region',
  municipality = 'municipality',
  school = 'school',
}

export interface ReportDataBasicStaticRow {
  id: string | null;
  name: string;
  type: ReportDataBasicStaticRowType | null;

  direction_count: number;
  direction_unconfirmed_count: number;
  direction_confirmed_count: number;

  event_count: number;
  event_in_progress_count: number;
  event_done_count: number;
  event_need_works_count: number;
  event_expired_count: number;
  event_confirmed_count: number;
}

interface ReportDataBasicStaticRoadmap {
  id: number;
  name: string;
  rows: ReportDataBasicStaticRow[];
}

export interface ReportDataBasicStatic {
  roadmaps: ReportDataBasicStaticRoadmap[];
}


// DirectionEventStatistics ///////////////////////////////////


export const enum ReportDataDirectionEventStatisticsRowType {
  roadmap_direction = 'roadmap_direction',
  base_event = 'base_event',
  school = 'school',
}

export interface ReportDataDirectionEventStatisticsRow {
  count: number;
  in_progress_count: null | number;
  unconfirmed_count: number;
  done_count: null | number;
  need_works_count: null | number;
  confirmed_count: number;
  expired_count: null | number;

  id: number;
  name: string;
  type: ReportDataDirectionEventStatisticsRowType;
}

interface ReportDataDirectionEventStatisticsRoadmap {
  id: number;
  name: string;
  rows: ReportDataDirectionEventStatisticsRow[];
}

export interface ReportDataDirectionEventStatistics {
  roadmaps: ReportDataDirectionEventStatisticsRoadmap[];
}
